export default __webpack_public_path__ + "static/media/close.2ebd9b60.svg";